import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { getDefaultTimeZone } from 'src/app/store/masterSetup'
import dayjs from 'dayjs'
import { getUserProfile } from 'src/app/store/auth'

export const useDisableFutureDates = () => {
  const defaultTimeZone = useSelector(getDefaultTimeZone)
  const userProfile = useSelector(getUserProfile)

  const disableFutureDates = (current: dayjs.Dayjs) => {
    return (
      current &&
      current.format('YYYY/MM/DD') >
        dayjs()
          .tz(userProfile?.client?.timeZoneId ?? defaultTimeZone?.code)
          .format('YYYY/MM/DD')
    )
  }

  return { disableFutureDates }
}
